import React, { FC } from 'react';
import { Loan } from '../../../interfaces';
import ListTile from '../../Common/ListTile';
import { BorrowerInfo } from './BorrowerInfo';

type Props = {
  loan: Loan;
};

export const RentLoanDetail: FC<Props> = ({ loan }) => {
  return (
    <>
      <h4 className='mtitle'>Property Detail</h4>
      <ListTile title='Rent' value={parseFloat(loan.amount).toLocaleString()} />
      {loan.other_cost && <ListTile title='Other Costs' value={parseFloat(loan.other_cost).toLocaleString()} />}
      <ListTile title='Address' value={`${loan.property_address}, ${loan.property_city}, ${loan.property_state.name}, ${loan.property_country.name}`} />

      <h4 className='mtitle'>Owner Detail</h4>
      <ListTile title='Name' value={loan.owner_name} />
      <ListTile title='Phone No.' value={loan.owner_phone} />
      {loan.owner_email && (
        <ListTile title='Email'>
          <span className='fs-7 fw-bold'>{loan.owner_email}</span>
        </ListTile>
      )}

      <BorrowerInfo borrower={loan.borrower} />
    </>
  );
};
